import Login from "../components/login/Login";
export default function LoginView(){
  return(
    <Login/>
  )
}